<template>
<div class="page-content-warehouse__body--content">
	<div class="d-flex justify-content-between header">
		<div>
			<span class="font-weight-bold"> Warehouse Aktif </span>
		</div>
	</div>
	<div class="mb-3">
		<button
			v-if="warehouseNotNull"
			@click="openFormWarehouse('add')"
			type="button"
			class="integration-app-button btn btn-primary"
		>
			+ <span class="ml-2">{{ $t("Add Warehouse") }}</span>
		</button>
	</div>
	<div class="content">
		<div class="row p-6" v-if="warehouseNotNull">
			<div class="col-12 col-md-6" v-for="(warehouse, i) in warehouses" :key="i">
				<div class="box box-padding">
					<div class="row">
						<div class="col-sm-8">
							<div class="d-flex justify-content-between align-items-center">
								<div class="d-flex p-1 bg-gray rounded h-auto w-auto">
									<i class="warehouse__icon material-icons">warehouse</i>
								</div>
								<div class="ml-3">
									<span
										class="integration__title"
									>
										{{ warehouse.label }}
									</span>
									<div class="integration__info"></div>
									<small
										class="text-left text-small"
										v-if="warehouse.address.length < 25"
									>
										{{ warehouse.address }},
										{{ setAddress(warehouse) }}
									</small>
									<small
										v-else
										v-tooltip="
											`${warehouse.address}, ${setAddress(warehouse)}`
										"
										class="mt-1 text-left text-small"
									>
										{{
											warehouse.address.length > 25
												? warehouse.address.substr(0, 25) + "... "
												: warehouse.address
										}},
										<span>
											{{ setAddress(warehouse) }}
										</span>
									</small>
								</div>
							</div>
						</div>
						<div class=" col-sm-4">
							<div class="d-flex justify-content-end">
								<button
									v-tooltip="$t('Edit Warehouse')"
									@click="openFormWarehouse('edit', warehouse)"
									class="btn bg-gray btn-light btn-sm mr-2"
								>
									<i class="material-icons btn-icon">edit</i>
								</button>
								<button
									v-tooltip="$t('Delete Warehouse')"
									@click="openModalDeleteWarehouse(warehouse)"
									class="btn bg-gray btn-light btn-sm"
								>
									<i class="material-icons btn-icon">delete</i>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="list-empty b-0">
			<div>
				<i class="material-icons md-48 mr-2">error_outline</i
				><span>Tidak Ada Data Warehouse.</span>
			</div>
			<div class="mt-2">
				<button
					@click="openFormWarehouse('add')"
					type="button"
					class="integration-app-button btn btn-primary"
				>
					+ <span class="ml-2">{{ $t("Add Warehouse") }}</span>
				</button>
			</div>
		</div>
	</div>
	<warehouse-form
		:show="isShowFormWarehouse"
		:formType="warehouseFormType"
		:selectedWarehouse="selectedWarehouse"
		@close="isShowFormWarehouse = false"
		@set="submit"
	/>
	<delete-warehouse
		v-if="isShowDeleteWarehouse"
		:warehouse="selectedWarehouse"
		@close="isShowDeleteWarehouse = false"
		@set="deleteDataWarehouse"
	/>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import WarehouseForm from '@/components/WarehouseForm.vue';
import DeleteWarehouse from '@/components/setting/Warehouse/section/modal/DeleteWarehouse.vue';

export default {
	name: 'SettingWarehouseSectionBodyContent',
	data() {
		return {
			// warehouses: [],
			warehouseFormType: '',
			isShowFormWarehouse: false,
			isShowDeleteWarehouse: false,
			selectedWarehouse: {},
		};
	},
	components: {
		WarehouseForm,
		DeleteWarehouse,
	},
	created() {
		// this.getWarehouses();
		this.getDataWarehouse();
	},
	computed: {
		...mapGetters({
			warehouses: 'warehouse/warehouses',
		}),
		warehouseNotNull() {
			return this.warehouses?.length > 0;
		},
	},
	methods: {
		...mapActions({
			getDataWarehouse: 'warehouse/getDataWarehouse',
			updateWarehouse: 'warehouse/updateWarehouse',
			deleteWarehouse: 'warehouse/deleteWarehouse',
			storeNewWarehouse: 'warehouse/storeNewWarehouse',
		}),

		/**
		 * Open Modal Form Edit Warehouse
		 *
		 * @param {Object} warehouse
		 * @this {String} warehouseFormType
		 * @this {Boolean} isShowFormWarehouse
		 * @this {Object} selectedWarehouse
		 */
		openFormWarehouse(type, warehouse = null) {
			this.warehouseFormType = type;
			this.isShowFormWarehouse = true;

			if (warehouse !== null) {
				this.selectedWarehouse = warehouse;
			}
		},

		/** */
		openModalDeleteWarehouse(warehouse = null) {
			this.selectedWarehouse = warehouse;
			this.isShowDeleteWarehouse = true;
		},

		/**
		 * Submit Form Update & Delete
		 *
		 * @param {Object} warehouse
		 * @this {Funtion} updateWarehouse
		 * @this {Funtion} storeNewWarehouse
		 */
		submit(warehouse) {
			if (this.warehouseFormType === 'edit') {
				this.updateWarehouse(warehouse);
				this.showNotify(
					this.$t('Update Warehouse'),
					this.$t('Warehouse Update Successfully'),
					'success',
				);
			} else {
				this.storeNewWarehouse(warehouse);
				this.showNotify(
					this.$t('Add Warehouse'),
					this.$t('Warehouse Added Successfully'),
					'success',
				);
			}
		},

		/**
		 * Check Data warehouse
		 *
		 * @param {String} type
		 * @param {Object} warehouse
		 * @private {Boolean} isNotNull
		 *
		 * @return {Boolean} isNotNull
		 */
		checkDataWarehouse(type, warehouse = null) {
			let isNotNull;
			if (warehouse) {
				if (type === 'subdistrict') {
					isNotNull =
						warehouse && warehouse.subdistrict && warehouse.subdistrict !== null;
				}
				if (type === 'city') {
					isNotNull = warehouse && warehouse.city && warehouse.city !== null;
				}
				if (type === 'province') {
					isNotNull = warehouse && warehouse.province && warehouse.province !== null;
				}
			}

			return isNotNull;
		},

		/**
		 * Delete Data Warehouse
		 *
		 * @param {String} _id
		 * @this {Boolean} isShowDeleteWarehouse
		 */
		deleteDataWarehouse(_id) {
			this.deleteWarehouse(_id);
			this.isShowDeleteWarehouse = false;
		},

		/**
		 * Assign Full address
		 *
		 * @param {Object} warehouse
		 * @private {String} address
		 *
		 * @return {String} address
		 */
		setAddress(warehouse) {
			// warehouse.address.length > 10 ?  warehouse.address.substr(0, 10) + '...' : warehouse.address }}, {{ warehouse.subdistrict.name }} , {{ warehouse.city.name }}, {{ warehouse.province.name }}
			const address = `${warehouse.subdistrict.name} ${warehouse.city.name} ${
				warehouse.province.name
			}`;
			return address;
		},
		/**
		 * Add new Warehouse
		 *
		 * @param {Object} warehouses
		 * @this {Funtion} updateWarehouse
		 */
		addNewWarehouse(warehouses) {
			this.storeNewWarehouse(warehouses);
		},
		/**
		 *  Show Notify
		 *
		 * @param {Sring} title
		 * @param {Sring} text
		 * @param {Sring} type
		 */
		showNotify(title, text, type) {
			this.$notify({
				group: 'app',
				title,
				text,
				type,
			});
		},
	},
};
</script>

<style scoped>
.warehouse__icon {
	font-size: 30px;
}
.bg-gray {
	background-color: #e1eaef;
}
.box-padding {
	padding: 25px;
	height: 120px;
}

.btn-rounded {
	border-radius: 100%;
	background: #e1eaef;
	margin: 0 0 0 10px;
	/* padding: 10px; */
}
.btn-icon {
	color: #21252999;
	font-size: 13px;
}
</style>
